export const languages = [
    {
        name: "English",
        value: "en"
    },
    {
        name: "Portuguese",
        value: "pt"
    }
]